import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";
import { citylist } from "../../../redux/actions/dbactions/refactions";
import { Icon } from "@iconify/react";
import { editfacility } from "../../../redux/actions/dbactions/facilityActions";
import { newfacility } from "../../../constants/Validation";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const EditModal = ({
  show,
  dispatch,
  onHide,
  selectedCountryId,
  setSelectedCountryId,
  setRefresh,
  setEditmodal,
}) => {
  const { currentData } = useSelector((state) => state.facilitylist);
  const { user_profile_id, role_id } = getSession();
  const { refsdata } = useSelector((state) => state.refstypes);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );
  const { newUser } = useSelector((state) => state.facilitylist);
  const [selectedImage, setSelectedImage] = useState(null);
  const [licenseImage, setLicensedImage] = useState(null);
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => { };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleLicImageChange = (event) => {
    const file = event.target.files[0];
    setLicensedImage(file);

    const reader = new FileReader();
    reader.onloadend = () => { };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (selectedCountryId) {
      dispatch(citylist(selectedCountryId));
    }
    // if (licenseImage) {
    //   console.log("file---->", licenseImage);
    // }
  }, [selectedCountryId, licenseImage]);

  const [selectedCityId, setSelectedCityId] = useState(null);
  const {
    svcf_name,
    svcf_desc,
    svcf_contact_phone_nbr,
    svcf_contact_email,
    svcf_addr_street1,
    svcf_addr_street2,
    svcf_allow_sms_yn,
    svcf_iso_cntry_id,
    svcf_allow_wup_sms_yn,
    svcf_addr_state,
    svcf_photo,
    svcf_license_url,
    svcf_iso_city_id,
    svcf_id,
    svcf_addr_zipcode,
    svcf_user_profile_id,
  } = currentData;
  const facilityTypes = refsdata.usr?.service_facility_type || [];
  const countryname = refsdata.usr?.iso_cntry || [];
  const citiesName = citis.usr?.iso_city || [];
  //facilityTypes Change
  const handleFacilityTypeChange = (event, setFieldValue) => {
    const selectedFacilityType = event.target.value;

    const selectedFacilityTypeObject = facilityTypes.find(
      (item) => item.svcft_typ_id === selectedFacilityType
    );

    setFieldValue("svcf_type_id", selectedFacilityType);
    setFieldValue("svcft_typ_id", selectedFacilityType);
  };
  //country handle change
  const handleCountryChange = (event, setFieldValue) => {
    const newSelectedCountryId = event.target.value;

    // Update selectedCountryId state
    setSelectedCountryId(newSelectedCountryId);

    // Dispatch citylist action
    dispatch(citylist(newSelectedCountryId));

    if (newSelectedCountryId) {
      setIsCountrySelected(true);
    } else {
      setIsCountrySelected(false);
    }

    setFieldValue("svcf_iso_cntry_id", newSelectedCountryId);
  };
  //city handle change
  const handleCityChange = (event, setFieldValue) => {
    const selectedCityId = event.target.value;

    setSelectedCityId(selectedCityId);
    //setFieldValue("svcf_addr_state", selectedCityId);
    setFieldValue("svcf_iso_city_id", selectedCityId);
  };

  const neWfacility = (values) => {
    dispatch(editfacility(values, svcf_id));
    setLicensedImage(null);
  };
  useEffect(() => {
    if (newUser?.usr?.rec) {
      setRefresh(true);
      setEditmodal(false);
    }
  }, [newUser]);
  const handleImageClick = () => {
    // Trigger file input click
    document.getElementById("fileInput").click();
  };

  const handleUploadClick = () => {
    // Trigger file input click
    document.getElementById("licFileInput").click();
  };
  const handleClose = () => {
    setLicensedImage(null);
    setEditmodal(false);
  };

  return (
    <Modal className="edit_modal profile " show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <h5 className="mb-0">{`xEdit Facility for ${svcf_name}`}</h5>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            svcf_user_profile_id: svcf_user_profile_id
              ? svcf_user_profile_id
              : user_profile_id,
            svcf_name: svcf_name || "",
            svcf_type_id:
              currentData && currentData.svcf_type_id
                ? currentData.svcf_type_id
                : facilityTypes.length > 0
                  ? facilityTypes[0].svcft_typ_id
                  : "",
            svcf_contact_email: svcf_contact_email || "",
            svcf_contact_phone_nbr: svcf_contact_phone_nbr || "",
            svcf_desc: svcf_desc || "",
            svcf_addr_street1: svcf_addr_street1 || "",
            svcf_addr_street2: svcf_addr_street2 || "",
            svcf_iso_cntry_id:
              currentData && currentData.svcf_iso_cntry_id
                ? svcf_iso_cntry_id
                : "",
            svcf_iso_city_id:
              currentData && currentData.svcf_iso_city_id
                ? currentData.svcf_iso_city_id
                : "",
            svcf_addr_state: currentData ? currentData.svcf_addr_zipcode : "",
            svcf_addr_zipcode: svcf_addr_zipcode || "",
            role_id: role_id,
            sys_user_id: user_profile_id,
            sys_fac_active_yn: "Y",
            svcf_allow_sms_yn: svcf_allow_sms_yn || "N",
            svcf_allow_wup_sms_yn: svcf_allow_wup_sms_yn || "N",
          }}
          validationSchema={newfacility}
          onSubmit={(values) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
            });
            if (selectedImage) {
              formData.append("picture", selectedImage);
            }
            if (licenseImage) {
              formData.append("license", licenseImage);
            }
            neWfacility(formData);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <div className="image_up" onClick={handleImageClick}>
                      {selectedImage || svcf_photo ? (
                        <div className="image-preview">
                          <img
                            src={
                              selectedImage
                                ? URL.createObjectURL(selectedImage)
                                : `${svcf_photo}`
                            }
                            alt="Preview"
                          />
                        </div>
                      ) : (
                        <div className="open_upload">
                          <Icon icon="line-md:upload-loop" />
                          <p>Upload Image</p>
                        </div>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                        name="svcf_photo"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${touched.svcf_name && errors.svcf_name
                            ? "is-invalid"
                            : ""
                          }`}
                        name="svcf_name"
                        placeholder="Facility Name"
                        type="input"
                        value={values.svcf_name}
                      />
                      <ErrorMessage name="svcf_name" component={Texterror} />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Form.Select
                        className="form-control"
                        name="svcf_type_id"
                        aria-label="Default select example"
                        onChange={(e) =>
                          handleFacilityTypeChange(e, setFieldValue)
                        }
                        value={values.svcf_type_id}
                      >
                        <option value="">Select Facility Type</option>
                        {facilityTypes.map((item, index) => (
                          <option key={index} value={item.svcft_typ_id}>
                            {item.svcft_typ_desc}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage name="svcf_type_id" component={Texterror} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${touched.svcf_contact_email &&
                            errors.svcf_contact_email
                            ? "is-invalid"
                            : ""
                          }`}
                        name="svcf_contact_email"
                        type="email"
                        placeholder="Email"
                        value={values.svcf_contact_email}
                      />
                      <ErrorMessage
                        name="svcf_contact_email"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <PhoneInput
                        country={"us"}
                        value={values.svcf_contact_phone_nbr}
                        onChange={(phone) =>
                          setFieldValue("svcf_contact_phone_nbr", phone)
                        }
                        inputProps={{
                          name: "svcf_contact_phone_nbr",
                          required: true,
                          className: `form-control ${touched.svcf_contact_phone_nbr &&
                              errors.svcf_contact_phone_nbr
                              ? "is-invalid"
                              : ""
                            }`,
                        }}
                      />
                      <ErrorMessage
                        name="svcf_contact_phone_nbr"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Col>
                      <div className="mb-3">
                        <Field
                          as={"textarea"}
                          rows={4}
                          className={`form-control ${touched.svcf_desc && errors.svcf_desc
                              ? "is-invalid"
                              : ""
                            }`}
                          name="svcf_desc"
                          placeholder="Facility Description"
                          type="input"
                          value={values.svcf_desc}
                        />
                        <ErrorMessage name="svcf_desc" component={Texterror} />
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${touched.svcf_addr_street1 && errors.svcf_addr_street1
                            ? "is-invalid"
                            : ""
                          }`}
                        name="svcf_addr_street1"
                        placeholder="Address line 1"
                        type="input"
                        value={values.svcf_addr_street1}
                      />
                      <ErrorMessage
                        name="svcf_addr_street1"
                        component={Texterror}
                      />
                    </div>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${touched.svcf_addr_street2 && errors.svcf_addr_street2
                            ? "is-invalid"
                            : ""
                          }`}
                        name="svcf_addr_street2"
                        type="input"
                        value={values.svcf_addr_street2}
                        placeholder="Address line 2"
                      />
                      <ErrorMessage
                        name="svcf_addr_street2"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={4}>
                    <div className="mb-3">
                      <Form.Select
                        className="form-control"
                        name="svcf_iso_cntry_id"
                        aria-label="Default select example"
                        onChange={(e) => handleCountryChange(e, setFieldValue)}
                        value={values.svcf_iso_cntry_id}
                      >
                        <option value="">{"Select Country Type"}</option>
                        {countryname.map((item, index) => (
                          <option key={index} value={item.iso_cntry_id}>
                            {item.iso_cntry_name}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage
                        name="svcf_iso_cntry_id"
                        component={Texterror}
                      />
                    </div>
                  </Col>{" "}
                  <Col lg={4}>
                    <div className="mb-3">
                      <div className="position-relative">
                        <Form.Select
                          className="form-control"
                          name="svcf_iso_city_id"
                          aria-label="Default select example"
                          onChange={(e) => handleCityChange(e, setFieldValue)}
                          //disabled={!isCountrySelected}
                          value={values.svcf_iso_city_id}
                        >
                          <option>Select City</option>
                          {citiesName.map((city) => (
                            <option
                              key={city.iso_city_id}
                              value={city.iso_city_id}
                            >
                              {city.iso_city_name}
                            </option>
                          ))}
                        </Form.Select>
                        {citiesLoading && (
                          <div className="loader-container">
                            <Spinner
                              animation="border"
                              size="sm"
                              variant="primary"
                            />
                          </div>
                        )}
                      </div>
                      <ErrorMessage
                        name="svcf_iso_city_id"
                        component={Texterror}
                      />
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Field
                        className={`form-control ${touched.svcf_iso_city_id && errors.svcf_iso_city_id
                            ? "is-invalid"
                            : ""
                          }`}
                        name="svcf_addr_zipcode"
                        placeholder="Zip Code"
                        type="input"
                        value={selectedCityId || svcf_iso_city_id}
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3 flex flex-col">
                  <Col lg={6} md={12}>
                    <div className="op mb-2">
                      <FormCheck
                        name="svcf_allow_sms_yn"
                        type="checkbox"
                        label="Yes, contact me via SMS"
                        checked={values.svcf_allow_sms_yn === "Y"}
                        onChange={() => {
                          setFieldValue(
                            "svcf_allow_sms_yn",
                            values.svcf_allow_sms_yn === "Y" ? "N" : "Y"
                          );
                        }}
                      />
                      {touched.svcf_allow_sms_yn &&
                        errors.svcf_allow_sms_yn && (
                          <div className="invalid-feedback">
                            {errors.svcf_allow_sms_yn}
                          </div>
                        )}
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="op mb-2">
                      <FormCheck
                        name="svcf_allow_wup_sms_yn"
                        type="checkbox"
                        label={
                          <span
                            style={{
                              fontWeight:
                                values.svcf_allow_wup_sms_yn === "Y"
                                  ? "normal"
                                  : "bold",
                              color:
                                values.svcf_allow_wup_sms_yn === "Y"
                                  ? "black"
                                  : "red",
                            }}
                          >
                            Yes, contact me via Whatsapp
                          </span>
                        }
                        checked={values.svcf_allow_wup_sms_yn === "Y"}
                        onChange={() => {
                          setFieldValue(
                            "svcf_allow_wup_sms_yn",
                            values.svcf_allow_wup_sms_yn === "Y" ? "N" : "Y"
                          );
                        }}
                      />
                      {touched.svcf_allow_wup_sms_yn &&
                        errors.svcf_allow_wup_sms_yn && (
                          <div className="invalid-feedback">
                            {errors.svcf_allow_wup_sms_yn}
                          </div>
                        )}
                    </div>
                    <div>
                      <Button
                        className="w-full !rounded-md !max-w-38 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                        variant="primary"
                        type="button"
                        onClick={handleUploadClick}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }} // Added flexbox styling for better alignment
                      >
                        <Icon
                          icon="tabler:license"
                          style={{ marginRight: "5px" }}
                        />{" "}
                        {/* Added margin to separate the icon from the text */}
                        {licenseImage
                          ? "File selected"
                          : "Upload license (OPC/HPA)"}
                      </Button>

                      <input
                        type="file"
                        id="licFileInput"
                        style={{ display: "none" }}
                        onChange={handleLicImageChange}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <Icon
                          icon="tabler:hand-finger-right"
                          style={{ marginRight: "5px" }}
                        />
                        {svcf_license_url ? (
                          <a
                            href={svcf_license_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              fontWeight: "normal",
                              textDecoration: "underline",
                            }}
                          >
                            {"License file: " + svcf_license_url.slice(-20)}
                          </a>
                        ) : !licenseImage ? (
                          <b
                            style={{
                              fontWeight: "bold",
                              color: "red",
                            }}
                          >
                            License NOT uploaded
                          </b>
                        ) : (
                          <a
                            style={{
                              color: "green",
                            }}
                          >
                            Click Submit to upload license
                          </a>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="mini_edit justify-end">
                      <Button
                        className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                        variant="secondary"
                        onClick={handleClose}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                        variant="primary"
                        type="submit"
                      >
                        Submit
                      </Button>
                    </div>
                  </Col>
                </Row>{" "}
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary">Delete</Button>
      </Modal.Footer> */}
    </Modal>
  );
};
